<div id="tcc-header" class="header">
  <div
    class="header_title"
    *ngFor="let nav of navLinks; let i = index"
    (click)="handleClick()"
  >
    {{ nav.title }}
  </div>
</div>
